/*eslint-disable*/
import Vue from 'vue'
import { getENV } from 'dingtalk-jsapi/lib/env'
import App from './App'
import router from './router'
import edwRegister from '@/lib/edw'
import store from './store'
import Vuex from 'vuex'
import '../public/static/css/reset.css'
import '../public/static/css/table-common.less'
import 'babel-polyfill'
import axios from 'axios'
import $server from './server.js'
import $config from './config.js'
import $Dictionaries from './data.js'
import * as filtersConfig from '@/filter.js'

import { base64Decode } from './util'
import { trackApiCall } from './utils/apiMonitor'
import MintUI from 'mint-ui'
import tsignData from '@tsign/tsigndata-sdk-js'
import VueClipboard from 'vue-clipboard2'
import { initMonitor, reportBusiness } from '@tsign/report-error'

import { getAndSetTokenInfo, getTokenHeader } from './tokenLogin.js'

import { i18n } from '@/locales'

tsignData.registerPage({
  PlatformType: 'WEB',
})

// 阿里云 前端监控
// if (process.env.VUE_APP_MODE === 'prod') {
// initMonitor({
//   pid: 'fkmlak58tj@0ce8151af543d99',
//   appType: 'web',
//   imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
//   sendResource: true,
//   enableLinkTrace: true,
//   behavior: true,
//   useFmp: true,
//   enableConsole: true,
//   environment: process.env.VUE_APP_MODE,
// })
// }

const appModeMap = {
  dev: 'default',
  test: 'default',
  sml: 'preparation',
  prod: 'production',
}
tsignData.init({
  mode: appModeMap[process.env.VUE_APP_MODE] || 'production',
})

try {
  Vue.prototype.$esignClientVersion = navigator.userAgent.match(/EsignClient\/([\d.]+)/)[1]
} catch (error) {}

store.commit('setTsignData', {
  _latest_tsign_source_type: tsignData.getPresetProperties()['_latest_tsign_source_type'],
  _latest_tsign_source_detail: tsignData.getPresetProperties()['_latest_tsign_source_detail'],
})

Vue.use(Vuex)
Vue.use(VueClipboard)
Vue.use(MintUI)
Vue.config.productionTip = false

Vue.prototype.$reportBusiness = reportBusiness
Vue.prototype.$Dic = $Dictionaries
Vue.prototype.$axios = axios
Vue.prototype.$ajax = $server
Vue.prototype.$url = $config

Object.keys(filtersConfig).forEach(key => {
  Vue.filter(key, filtersConfig[key])
})

const isDingtalk = getENV().platform === 'pc'
Vue.prototype.isDingtalk = isDingtalk

// 钉签下，从url中拿到corpId, appId
const getQueryString = name => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
  const r = window.location.search.substr(1).match(reg)
  if (r != null) {
    sessionStorage.setItem(name, unescape(r[2]))

    return unescape(r[2])
  }

  return null
}

const $dingCorpId = getQueryString('dingCorpId') || sessionStorage.getItem('dingCorpId') || localStorage.getItem('corpId')
const $dingUserId = getQueryString('dingUserId') || sessionStorage.getItem('dingUserId') || localStorage.getItem('dingUserId')

// 判断H5
store.commit('setIsH5', window.screen.width <= 768)
store.commit('setShowOrderBtn', getQueryString('showOrderBtn'))
// eslint-disable-next-line complexity
router.beforeEach(async (to, from, next) => {
  await getAndSetTokenInfo()
  getTokenHeader()
  let query = {}
  if (to.query.hasOwnProperty('operating')) {
    query = JSON.parse(base64Decode(to.query.operating))
    query.agentId && sessionStorage.setItem('agentId', query.agentId)
    query.ditchID && sessionStorage.setItem('ditchID', query.ditchID)
    const { inviteId } = to.query
    if (query.ctype == 1 && !query.organ) {
      const inviteeDataRes = await $server($config.inviteeData(inviteId))
      query.organ = inviteeDataRes.data.output.orgId
    }
  } else {
    query = to.query
  }
  const { userInfo } = store.state
  // 如果是微应用隐藏侧边和顶部导航栏 || 或者ep项目下sessionStorage缓存了hideSideMenu
  store.commit('setHideSideMenu', !!window.__POWERED_BY_QIANKUN__ || sessionStorage.getItem('hideSideMenu') === 'true')
  // 切换企业主体
  const hasNewOrgId = userInfo.orgId !== query.orgId || userInfo.orgId === undefined || query.orgId === undefined
  if (to.path === '/infoCheck') {
    next()
  } else if (JSON.stringify(userInfo) === '{}' || hasNewOrgId) {
    const url = isDingtalk ? $config.getDingOrg($dingCorpId) : $config.getOrg()
    // [埋点] 监控接口调用
    trackApiCall(url.url)
    const body = isDingtalk ? { userId: $dingUserId } : {}
    Promise.all([$server(url, body), $server($config.getInfo())]).then(async res => {
      const orgRes = res[0]
      const infoRes = res[1]
      query.returnUrl && localStorage.setItem('returnUrl', query.returnUrl)
      store.commit('setIsOrg', false)
      // ctype 1 企业 0 个人
      if (query.ctype != 0) {
        let orgInfo =
          orgRes.data.bizUserInfoOutputs.find(item => {
            return item.orgId == query.organ
          }) ||
          orgRes.data.bizUserInfoOutputs.find(item => {
            return item.isMain
          })
        // 优先取主体和url中的organ匹配的企业，如果不存在主企业isorg变为false
        if (orgInfo) {
          store.commit('setUserInfo', {
            realName: orgInfo.realName,
            name: orgInfo.orgName,
            gid: orgInfo.orgGuid || orgInfo.guid,
            orgId: orgInfo.orgId,
            contacts: infoRes.data.loginInfo.idcard,
            isAdmin: orgInfo.roleDetailList.some(v => v.roleKey === 'ADMIN' || v.roleKey === 'FEE_ADMIN'),
          })
          store.commit('setIsOrg', true)
          // 切换当前空间为进入的企业
          if (store.state.userInfo.orgId) {
            await $server($config.space(store.state.userInfo.orgId))
          }
        } else {
          store.commit('setIsOrg', false)
        }
      }
      // 缓存一下用户的ouid
      infoRes.data.baseRealname.ouid && localStorage.setItem('ouid', infoRes.data.baseRealname.ouid)
      // 缓存用户gid
      infoRes.data.baseRealname.guid && localStorage.setItem('guid', infoRes.data.baseRealname.guid)
      // 未实名认证
      if (!infoRes.data.baseRealname.status) {
        store.commit('setUserInfo', {
          realName: infoRes.data.baseRealname.status,
          name: infoRes.data.prop.properties.name,
          gid: infoRes.data.base.guid,
          isAdmin: infoRes.data.base.type == 'PERSON',
          contacts: infoRes.data.loginInfo.idcard,
        })
        store.commit('setIsOrg', false)
        next('/infoCheck')
      }
      //根据路由判断是否是ep计费使用  企业用户

      if (store.state.isOrg) {
        if (store.state.userInfo.gid) {
          if (to.redirectedFrom && to.redirectedFrom.includes('/epBilling')) {
            store.commit('setIsPartner', true)
            store.commit('setHideSideMenu', true)
            next({
              path: '/MyOrder',
              query,
            })
          } else {
            next()
          }
        } else {
          next('/infoCheck')
        }
      } else {
        // 个人用户
        store.commit('setUserInfo', {
          realName: infoRes.data.baseRealname.status,
          name: infoRes.data.prop.properties.name,
          gid: infoRes.data.base.guid,
          isAdmin: infoRes.data.base.type == 'PERSON',
          contacts: infoRes.data.loginInfo.idcard,
        })
        if (store.state.userInfo.gid) {
          // 根据路由判断是否是ep计费使用
          if (to.redirectedFrom && to.redirectedFrom.includes('/epBilling')) {
            store.commit('setIsPartner', true)
            store.commit('setHideSideMenu', true)
            next({
              path: '/MyOrder',
              query,
            })
          } else {
            next()
          }
        } else {
          next('/infoCheck')
        }
      }
    })
  } else {
    to.path === '/infoCheck' ? next() : userInfo.gid ? next() : next('/infoCheck')
  }
})

/** qiankun本地运行时配置 */
const NGINX_MODE = ['test', 'sml', 'prod']
const MODE = process.env.VUE_APP_MODE
const IS_NGINX_MODE = NGINX_MODE.includes(MODE)
// eslint-disable-next-line no-underscore-dangle
if (window.__POWERED_BY_QIANKUN__ && !IS_NGINX_MODE) {
  // eslint-disable-next-line no-undef,camelcase,no-underscore-dangle
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}

/** 初始化Vue实例 */
let instance = null
function render({ container } = {}) {
  const mixins = {
    data() {
      return { isQianKun: window.__POWERED_BY_QIANKUN__ || false }
    },
  }
  instance = new Vue({
    mixins: [mixins],
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount(container ? container.querySelector('#app') : '#app')
}

// 注册EDW组件、加载edw样式
const handleEdw = () => {
  require('../src/assets/css/resetEdw.css')
  edwRegister()
}

/**********  费用中心独立运行时 ***********/
if (!window.__POWERED_BY_QIANKUN__) {
  handleEdw()
  render()
}

/**********  费用中心作为子应用运行时 ***********/
export async function bootstrap(app) {
  /** 开放企业控制台特殊场景
   * 1. 开放企业控制台主应用未使用 SaaS 子包注册EDW
   * 2. 开放企业控制台主应用 Vue库不是使用 CDN 形式引入导致本工程无法与主应用共享 Vue 实例并使用EDW组件
   * 只能代码识别开放企业控制台主应用场景独立注册edw
   */
  if (app.routerBase === '/open-enterprise') {
    handleEdw()
  }
  // SaaS 场景公用主应用Vue实例，无需注册EDW
  console.log('[vue] vue app bootstraped')
}

export async function mount(props) {
  console.log('[vue] props from main framework', props)
  render(props)
}

export async function unmount() {
  instance.$destroy()
  instance = null
}
